export default __webpack_public_path__ + "static/media/43.1a1619a8.jpeg";